module.exports = __webpack_public_path__ + "img/1.59b59a11.png";